import api from "../../api/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

//-------------------Get all the users when searched---------------------------------------
export const getAllUsersByNames = async (data) =>
  await api.get(`searchUserByUsername/fellow/${data.searchString}`);
//--------------------------------------------------------------------------------------------

//---------------------Get the available userdata------------------------------------------

export const getAvailableUserdata = async (data) =>
  await api.get(`getAllModuleWiseCount/${data.userid}`);

//-----------------------------------------------------------------------------------------

//------------------When all the checkboxes are selected-----------------------------------
export const deleteAllUserdata = async (data) => {
  console.log("api data sent------------>", data);
  try {
    const response = await api.delete(`deleteUserRecords`, { data });
    return response;
  } catch (error) {
    console.error("Error deleting specific userdata:", error);
    throw error;
  }
};
//----------------------------------------------------------------------------------------------

//----------------------When specific checkboxes are selected-------------------------------
export const deleteSpecificUserdata = async (data) => {
  console.log("api data sent------------>", data);
  try {
    const response = await api.delete(`deleteUserRecords`, { data });
    return response;
  } catch (error) {
    console.error("Error deleting specific userdata:", error);
    throw error;
  }
};
//----------------------------------------------------------------------------------------------
